/**
 * Application configuration constants
 * Centralized location for all configurable values
 */

/**
 * Colors for painting tool and UI elements
 * Values can be any valid color name, hex value, or rgba
 * e.g. "green", "#00ff00", rgba(0,255,0,1.0)
 */
export const COLORS = {
  /** Paint brush color - avoid transparent colors */
  paint: "rgba(43, 227, 150)",
  /** Active icon color */
  iconActive: "#1565C0",
  /** Inactive icon color */
  iconInactive: "#757575",
  /** Button background color */
  button: "whitesmoke",
};

/**
 * Brush size configurations (radius in pixels)
 */
export const BRUSH_SIZES = {
  /** Used specifically for perimeter measurement */
  tiny: 3,
  small: 6,
  medium: 12,
  large: 18,
};

/**
 * Images to preload for better UX during tours
 */
export const PRELOAD_IMAGES = [
  "/measur.it-intro.png",
  "/Measureit-logo.png",
  "/measurit-pan-zoom.gif",
  "/measur.it-draw-undo.gif",
];

/**
 * Map dimension constraints
 * Based on Google Maps Static API limitations
 * Pay-As-You-Go max values are 640
 * Premium Plan gets you 2048
 * @see https://developers.google.com/maps/documentation/maps-static/usage-and-billing
 */
export const MAP_LIMITS = {
  maxDimension: 940,
  breakpoint: 640,
};

/**
 * MUI Theme configuration
 */
export const THEME_CONFIG = {
  typography: {
    fontFamily: ["Open Sans", "sans-serif"].join(","),
  },
};
